import SectionHeader from "../common/SectionHeader";
import { getLandingProjects } from "../../utils/landingAcf";
import { SECTION_CONTAINER } from "../../utils/layout";

function LandingProjects({ acf, resolveImage }) {
  const { title, description, images } = getLandingProjects(acf);

  if (!title && !description && images.length === 0) return null;

  return (
    <section className="caf-section caf-section--light">
      <div className="caf-section__block caf-section__block--spaced">
        {title || description ? (
          <SectionHeader
            title={title || undefined}
            subtitle={description || undefined}
            showAccent
            titleId="landing-projects-title"
          />
        ) : null}
        {images.length > 0 ? (
          <div
            className={`${SECTION_CONTAINER} grid grid-cols-2 gap-4 md:grid-cols-4`}
            aria-labelledby={title ? "landing-projects-title" : undefined}
          >
            {images.map(({ id, imageId }) => {
              const src = resolveImage(imageId);
              if (!src) return null;
              return (
                <figure key={id} className="caf-media-frame aspect-square overflow-hidden">
                  <img src={src} alt="" loading="lazy" className="h-full w-full object-cover" />
                </figure>
              );
            })}
          </div>
        ) : null}
      </div>
    </section>
  );
}

export default LandingProjects;
